export const PRODUCT_NAME = 'NALVRA SERVICE';

export function hasOperatorBranding(values: {
  appName?: string | null;
  logoUrl?: string | null;
  portalTitle?: string | null;
  portalLogoUrl?: string | null;
}): boolean {
  const name = values.appName?.trim();
  return !!((name && name !== PRODUCT_NAME && name !== 'AISupportDesk') ||
    values.logoUrl || values.portalTitle?.trim() || values.portalLogoUrl);
}

export function brandingFooter(values: {
  brandingAllowed?: boolean;
  showVendor?: boolean;
  hasOperatorBrand?: boolean;
  customCopyright?: string | null;
  operatorName?: string | null;
  vendorFooter?: string | null;
}): string {
  if (values.brandingAllowed && (!values.showVendor || values.hasOperatorBrand)) {
    return values.customCopyright?.trim() || `© ${new Date().getFullYear()} ${values.operatorName?.trim() || PRODUCT_NAME}`;
  }
  return values.vendorFooter?.trim() || `© ${new Date().getFullYear()} ${PRODUCT_NAME}`;
}
